import React from 'react';
import TeacherDay2023 from 'views/SchoolProgram2023/TeacherDay2023';

const SchoolProgrampage = () => {
  return <TeacherDay2023 />;
};

export default SchoolProgrampage;